var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcFlagDrc = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6BFD625E-64E1-40CB-9031-A676899211F4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 10.2857143,
    cy: 10.2857143,
    r: 10.2857143
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "POC-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00.00.04-Enter-Phone-Number:-Typing",
    transform: "translate(-38.000000, -284.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inoput",
    transform: "translate(24.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Star-BG",
    stroke: "#EBEBEB",
    strokeWidth: 0.857142857,
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 11.5714286
  }), /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(1.714286, 1.714286)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#D8D8D8",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flag_of_the_Democratic_Republic_of_the_Congo",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.571429, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#007FFF",
    x: 0,
    y: 0,
    width: 26.5714286,
    height: 20.5714286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19571429,4.11428571 L3.98571429,4.11428571 L4.84928571,1.23428571 L5.71285714,4.11428571 L8.50285714,4.11428571 L6.24428571,5.89714286 L7.10785714,8.77714286 L4.84928571,6.99428571 L2.59071429,8.77714286 L3.45428571,5.89714286 L1.19571429,4.11428571 Z M24.9107143,0 L0,15.4285714 L0,20.5714286 L0,20.5714286 L1.66071429,20.5714286 L26.5714286,5.14285714 L26.5714286,0 L24.9107143,0",
    id: "Shape",
    fill: "#F7D618"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#CE1021",
    points: "26.5714286 0 0 16.4571429 0 20.5714286 0 20.5714286 0 20.5714286 26.5714286 4.11428571 26.5714286 0"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcFlagDrc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_flag_drc.6ae60f3f35f6cf5671c46e8a619a90d4.svg";